import { getCountries } from 'react-phone-number-input'
import countryLabels from 'react-phone-number-input/locale/en.json'

import { SelectOption } from '@/components/ui/inputs/SelectInput'

/**
 * Major Saudi cities offered in the SEHA (en-SA) patient address dropdown.
 * Values are stored as plain display names because `contactInfo.city` is a
 * free-text field for every other locale.
 */
export const SAUDI_CITIES = [
  'Abha',
  'Al Ahsa',
  'Al Baha',
  'Al Jubail',
  'Al Kharj',
  'Al Khobar',
  'Al Qatif',
  'Arar',
  'Buraidah',
  'Dammam',
  'Dhahran',
  'Hafar Al Batin',
  'Hail',
  'Jazan',
  'Jeddah',
  'Khamis Mushait',
  'Mecca',
  'Medina',
  'Najran',
  'Riyadh',
  'Sakaka',
  'Tabuk',
  'Taif',
  'Yanbu',
]

export const SAUDI_CITY_OPTIONS: SelectOption[] = SAUDI_CITIES.map((city) => ({ label: city, value: city }))

/**
 * Full ISO country list (English display names), stored as display names for
 * the same free-text compatibility reason as cities.
 */
export const COUNTRY_OPTIONS: SelectOption[] = getCountries()
  .map((country) => ({ label: countryLabels[country], value: countryLabels[country] }))
  .sort((a, b) => a.label.localeCompare(b.label))

/** Ensure a stored value that is not part of the predefined list stays selectable. */
export function withCurrentValueOption(options: SelectOption[], value?: string): SelectOption[] {
  if (!value || options.some((option) => option.value === value)) return options
  return [{ label: value, value }, ...options]
}
